export default class FormatTextUtil {
    /**
     * @author Pedro Antonio
     * @description Normalize text (exclude diacritical, included ñ and Ñ)
     * ```js
     * // Diacritical in Í from 'Martínez'
     * const name = "PEDRO ANTONIO MARTÍNEZ"
     * return "PEDRO ANTONIO MARTINEZ"
     * // Diacritical in Ñ from 'PIÑÓN'
     * const name = "LUIS ALEJANDRO PIÑÓN"
     * return "LUIS ALEJANDRO PINON"
     * ```
     * @param {string} text
     */
    static normalizeTextExcludedÑ(text) {
        return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    }

    /**
     * @author Pedro Antonio
     * @description Normalize text (exclude diacritical, not apply to ñ and Ñ)
     * ```js
     * // Diacritical in Í from 'Martínez'
     * const name = "PEDRO ANTONIO MARTÍNEZ"
     * return "PEDRO ANTONIO MARTINEZ"
     * // Diacritical in Ñ from 'PIÑÓN'
     * const name = "LUIS ALEJANDRO PIÑÓN"
     * return "LUIS ALEJANDRO PIÑON"
     * ```
     * @param {string} text
     * @returns {string}
     */
    static normalizeTextIncludedÑ(text) {
        return text.normalize('NFD').replace(/([aeio])\u0301|(u)[\u0301\u0308]/gi, '$1$2')
    }
}
